import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { ConsumptionModeType } from 'services/consumptionMode/consumptionMode.type';
import { RootState } from '../store';

export const appSliceName = 'app';

export type AppState = {
    restaurantId: number | null;
    currentMenuId: number | null;
    tableId: number | null;
    currentConsumptionModeType: ConsumptionModeType | null;
};

const initialState: AppState = {
    restaurantId: null,
    currentMenuId: null,
    tableId: null,
    currentConsumptionModeType: null,
};

export const appSlice = createSlice<AppState, SliceCaseReducers<AppState>, string>({
    name: appSliceName,
    initialState,
    reducers: {
        updateAppState: (state, action: PayloadAction<Partial<AppState>>) => ({
            ...state,
            ...action.payload,
        }),
    },
});

export const getAppState = (state: RootState): AppState => state.app;
export const getTableId = (state: RootState) => getAppState(state).tableId;
export const getRestaurantId = (state: RootState) => getAppState(state).restaurantId;
export const getCurrentMenuId = (state: RootState) => getAppState(state).currentMenuId;
export const getCurrentConsumptionModeType = (state: RootState) =>
    getAppState(state).currentConsumptionModeType;

export const { updateAppState } = appSlice.actions;
